import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from 'actions/actionConstants'
import {
  FETCH_BOOKING_PROTECTION_QUOTE,
} from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'

const initialState: App.BookingProtectionState = {
  triedFetchingQuotes: false,
  fetchingQuotes: {},
  quotes: {},
}

const apiCalls = apiReducerSwitch<App.BookingProtectionState>({
  [FETCH_BOOKING_PROTECTION_QUOTE]: {
    request: (state, action) => ({
      triedFetchingQuotes: true,
      fetchingQuotes: {
        ...state.fetchingQuotes,
        [action.key]: true,
      },
    }),
    success: (state, action) => ({
      fetchingQuotes: {
        ...state.fetchingQuotes,
        [action.key]: false,
      },
      quotes: {
        ...state.quotes,
        [action.key]: action.data,
      },
    }),
    failure: (state, action) => ({
      fetchingQuotes: {
        ...state.fetchingQuotes,
        [action.key]: false,
      },
    }),
  },
})

const bookingProtectionReducer = createAppReducer<App.BookingProtectionState>(initialState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
})

export default bookingProtectionReducer
